<template>
  <div class="spin-block">
    <div class="lds-ring" :class="{ small }">
      <div></div><div></div><div></div><div></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoadingSpinner",
  props: {
    small: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.spin-block {
  position: absolute;
  top: 0; left: 0;
  display: flex; align-items: center; justify-content: center;
  width: 100%; height: 100%;
}

.lds-ring {                /* default (large) */
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid #2C5697;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #2C5697 transparent transparent transparent;
}
.lds-ring div:nth-child(1) { animation-delay: -0.45s; }
.lds-ring div:nth-child(2) { animation-delay: -0.3s; }
.lds-ring div:nth-child(3) { animation-delay: -0.15s; }

/* small variant */
.lds-ring.small {
  width: 24px;
  height: 24px;
}
.lds-ring.small div {
  width: 20px;
  height: 20px;
  margin: 2px;
  border-width: 3px;
}

@keyframes lds-ring {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
